import MarketNewsDTO from "@domains/dto/MarketNewsDTO";
import NewOnEdelDTO from "@domains/dto/NewOnEdelDTO";
import urlConfig from "@adapters/infrastructures/urlConfig/homeUrl";
import LiveNewsDTO from "@domains/dto/LiveNewsDTO";
import { LiveNewsDataMapper } from "@domains/useCases/homepagemapper/LiveNewsDataMapper";
import { MarketNewsDataMapper } from "@domains/useCases/homepagemapper/MarketNewsDataMapper";
class CommonQuotesHomePageRepository {
    constructor(http) {
        this.http = http;
    }
    async getNewOnEdelData() {
        const newOnEdelData = await this.http.makeApiCall({
            method: "GET",
            url: urlConfig.newOnEdel,
        });
        if (newOnEdelData) {
            var newOnEdel = newOnEdelData.data.map((newOnEdel) => new NewOnEdelDTO(newOnEdel));
            return newOnEdel;
        }
    }
    async fetchLiveNews(requestData) {
        const liveNewsData = await this.http.makeApiCall({
            method: "POST",
            url: urlConfig.liveNewsUrl,
            body: {
                exclCategory: requestData.exclCategory ? requestData.exclCategory : ["Block_Details"],
                validRequest: false,
                inclCategory: requestData.inclCategory ? requestData.inclCategory : [],
                page: 0,
                group: "NG",
                searchText: "",
                dateTime: "",
            },
        });
        if (liveNewsData) {
            var liveNewsDataList = liveNewsData.data.listResponse.content.map((liveNews) => new LiveNewsDTO(liveNews));
            if (liveNewsDataList.length > 10) {
                return liveNewsDataList.slice(0, 6);
            }
            else {
                return liveNewsDataList.slice(0, liveNewsDataList.length);
            }
        }
    }
    async getLiveNewsData(requestData) {
        return new LiveNewsDataMapper().mapTo(await this.fetchLiveNews(requestData));
    }
    async getMarketNewsData() {
        const marketnewsData = await this.http.makeApiCall({
            method: "POST",
            url: urlConfig.marketNewsUrl,
            body: {
                pgNo: 1,
            },
        });
        if (marketnewsData) {
            var marketnewsDataList = marketnewsData.data.nwLst.map((marketNews) => new MarketNewsDTO(marketNews));
            return new MarketNewsDataMapper().mapTo(marketnewsDataList);
        }
    }
}
export default CommonQuotesHomePageRepository;
